import React, { useEffect, useState } from "react";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import { Card } from "@mui/material";
import CustomSwitch from "components/CustomSwitch";
import SuiButton from "components/SuiButton";
import { Button, CircularProgress } from "@mui/material";
import {
  updateDietChartConfiguration,
  getDietChartConfiguration,
  userSelector,
  clearState,
} from "store/features/authSlice";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";

const DietChartApproval = () => {
  const [checked, setChecked] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const dispatch = useDispatch();
  const { uid, dietChartConfiguration, isSuccess, message, isError } =
    useSelector(userSelector);
  useEffect(() => {
    dispatch(getDietChartConfiguration({ uid }));
  }, [dispatch, uid]);
  useEffect(() => {
    if (dietChartConfiguration) {
      setChecked(dietChartConfiguration);
    }
  }, [dietChartConfiguration]);
  const handleChange = () => {
    setChecked((prev) => !prev);
  };
  const handleSaveSettings = async () => {
    setLoadingSave(true);
    await dispatch(
      updateDietChartConfiguration({ newDietChartConfiguration: checked, uid })
    );
    await dispatch(getDietChartConfiguration({ uid }));
    setLoadingSave(false);
    setIsEdit(false);
  };
  useEffect(() => {
    if (isSuccess) {
      dispatch(clearState());
      toast.success(message);
    }
    if (isError) {
      dispatch(clearState());
      toast.error(message);
    }
  }, [isSuccess, isError, message, dispatch]);
  return (
    <Card sx={{ height: "100%", width: "100%", overflow: "initial" }}>
      <SuiBox
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        padding={2}
        gap={1}
        width="100%"
        mt={2.5}
        height="100%"
        justifyContent="space-between"
      >
        <SuiTypography mb={1} variant="h6" textAlign="left">
          Approval Settings for Diet Charts
        </SuiTypography>
        <SuiBox width="100%" display="flex" gap={1} justifyContent="center">
          <SuiTypography>Off</SuiTypography>
          <CustomSwitch
            checked={checked}
            onChange={handleChange}
            disabled={!isEdit}
          />
          <SuiTypography>On</SuiTypography>
        </SuiBox>
        <SuiBox width="100%" mt={3}>
          {isEdit ? (
            <SuiButton
              component={Button}
              color="dark"
              variant="gradient"
              onClick={handleSaveSettings}
              fullWidth
            >
              {loadingSave ? (
                <>
                  Save &nbsp;
                  <CircularProgress color="white" size={"1rem"} />
                </>
              ) : (
                "Save"
              )}
            </SuiButton>
          ) : (
            <SuiButton
              component={Button}
              color="dark"
              variant="gradient"
              onClick={() => setIsEdit(true)}
              fullWidth
            >
              Edit
            </SuiButton>
          )}
        </SuiBox>
      </SuiBox>
    </Card>
  );
};

export default DietChartApproval;
